import React from 'react';
import Link from '@material-ui/core/Link';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import ModalContent from '../ModalContent';
import * as Regex from '../../regex';

function Login({ submitLoginWithFireBase, setActiveModal }) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {},
  });

  const handleSignupModalOpen = () => {
    setActiveModal('signup');
  };

  const handleResetModalOpen = () => {
    setActiveModal('resetPassword');
  };

  const onSubmit = async (data) => {
    const { email, password } = data;

    try {
      const loginRes = await submitLoginWithFireBase({
        email,
        password,
      });
      if (loginRes.type === 'LOGIN_ERROR') {
        alert(loginRes.payload.message);
        return;
      }
    } catch (err) {
      console.warn('Login server error: ', err);
      alert('Login connection error');
      return;
    }

    setActiveModal('none');
  };

  return (
    <ModalContent
      title="Login"
      buttonText="Login"
      onFormSubmit={handleSubmit(onSubmit)}
      formContents={
        <>
          <FormTextField
            fullWidth
            label="Email"
            name="email"
            margin="normal"
            required
            error={!!errors.email}
            helperText={errors.email && errors.email.message}
            inputRef={register({
              required: 'Provide your login email',
              pattern: {
                value: Regex.email,
                message: 'Provide a valid email address',
              },
            })}
            placeholder="Enter Email"
          />
          <FormTextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            required
            error={!!errors.password}
            helperText={errors.password && errors.password.message}
            inputRef={register({
              required: 'Provide the password',
              minLength: {
                value: 5,
                message: 'Password too short',
              },
            })}
          />
        </>
      }
      footerContents={
        <>
          <Link
            component="button"
            variant="body2"
            onClick={handleResetModalOpen}
          >
            Forgot password?
          </Link>
          <Link
            component="button"
            variant="body2"
            onClick={handleSignupModalOpen}
          >
            Don't have an account? Sign Up
          </Link>
        </>
      }
    />
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLoginWithFireBase: actions.submitLoginWithFireBase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(Login));
